/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedModelEntityModelApplicationVersionDto } from '../models/PagedModelEntityModelApplicationVersionDto';
import type { PagedResourcesAssemblerApplicationVersionDto } from '../models/PagedResourcesAssemblerApplicationVersionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeviceApplicationVersionControllerService {
    /**
     * @returns PagedModelEntityModelApplicationVersionDto OK
     * @throws ApiError
     */
    public static list({
        deviceId,
        assembler,
        page,
        size = 20,
        sort,
    }: {
        deviceId: number,
        assembler: PagedResourcesAssemblerApplicationVersionDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelApplicationVersionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices/{deviceId}/applicationVersions',
            path: {
                'deviceId': deviceId,
            },
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
}
